import { DetailSection } from '@periscopes/general';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeTagList } from '@periscopes/general/tags';
import React from 'react';

export interface FieldTagsTabProps {
	index: number;
	tagIds: Array<number>;
}

export const FieldTags: React.FC<FieldTagsTabProps> = ({ index, tagIds }) => {
	const title = `${PERISCOPE_TAB_TYPES.TAGS} (${tagIds.length})`;

	return (
		<DetailSection
			spacing='small'
			title={ title }>
			<PeriscopeTagList
				parentIndex={ index }
				tagIds={ tagIds } />
		</DetailSection>
	);
};
